var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80332 9.18227C1.54732 9.18227 1.29132 9.08494 1.09665 8.88894C0.705983 8.49827 0.705983 7.86627 1.09665 7.47561L7.48598 1.08627C7.87665 0.695607 8.50865 0.695607 8.89932 1.08627C9.28998 1.47694 9.28998 2.10894 8.89932 2.49961L2.50998 8.88894C2.31532 9.08494 2.05932 9.18227 1.80332 9.18227",
    fill: "#7E808F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1953 9.18613C7.9393 9.18613 7.6833 9.0888 7.48863 8.8928L1.09396 2.4968C0.703298 2.10613 0.703298 1.47413 1.09396 1.08347C1.48596 0.6928 2.11796 0.6928 2.5073 1.08347L8.90196 7.47947C9.29263 7.87013 9.29263 8.50213 8.90196 8.8928C8.7073 9.0888 8.44996 9.18613 8.1953 9.18613",
    fill: "#7E808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/iconCross.20bd49a6168a4cc17c722eeb2ea25c07.svg";
export { ForwardRef as ReactComponent };